<template>
  <el-dialog
    width="540px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
    <div class="title">手动生成工资表</div>
    <div>
    <el-radio-group v-model="type" style="margin-bottom:20px;">
      <el-radio :label="false">复制上月当期数据</el-radio>
      <el-radio :label="true">生成零工资记录，用户手动修改</el-radio>
    </el-radio-group>
    <div class="acc_flex" v-if="!type" style="margin-bottom:20px;">
      五险一金：
      <el-radio-group v-model="useLastInsure" style="margin-left:15px;">
        <el-radio :label="true">复制上月</el-radio>
        <el-radio :label="false">员工设置</el-radio>
      </el-radio-group>
    </div>
      <div class="acc_flex">
        请选择账期：

        <el-date-picker
          v-model="yearMonths"
          type="months"
          placeholder="选择月"
          format="yyyy 年 MM 期"
          value-format="yyyyMM"
          size="small"
          style="width: 325px"
        ></el-date-picker>
      </div>
      <div v-if="yearMonths&&yearMonths.length" style="margin-top:20px;display:flex" >
        已选择账期：
        <div style="width:350px;">
           <el-tag v-for="(item,i) in yearMonths" :key="i" style="margin-right:10px;margin-bottom:10px;" closable @close="closeYear(item)">{{item|filterItem}}</el-tag>
        </div>
      </div>
      <div style="color: #ff3049; margin-top: 20px">
        已生成计提工资凭证的账期不支持重置「重置不可逆」！！！
      </div>
    </div>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { resetSalary } from "@/api/index.js";
export default {
  props: {
    resetDate: {
      type: Array,
      default: () => [],
    },
  },
  filters:{
    filterItem(val){
      let year = val.slice(0,4)
      let month = val.slice(4)
      return `${year}年${month}期`
    },
  },
  data() {
    return {
      useLastInsure:true,
      type:false,
      yearMonths: [],
      yearList: [],
      visible: false,
    };
  },
  methods: {
    closeYear(val){
      console.log(val)
      let i = this.yearMonths.indexOf(val)
      if(i>-1){
        this.yearMonths.splice(i,1)
      }
    },
    openTask() {
      this.visible = true;
      this.yearMonths = [];
    },
    submit() {
      let list  = this.yearMonths.map(e=>{
        return e.slice(0,4)
      })
      list = [...new Set(list)]
      console.log(list)
      if(list.length>1){
        this.$message.error('只能选择同一年份账期')
        return
      }
      let yearMonths = this.yearMonths.join(",");
      if(yearMonths===''){
        this.$message.error('请选择账期')
        return
      }
      let obj = {
        yearMonths,
        isReset:this.type
      }
      if(!this.type){
        obj.useLastInsure = this.useLastInsure
      }
      resetSalary(obj).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.visible = false;
          this.$emit("refsh");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/ResetPayRoll.vue